<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.6">
    <path
      opacity="0.65"
      d="M20.0498 15.0479C19.8174 15.0479 19.6191 15.1367 19.4414 15.3145L14.2256 20.6465C14.0752 20.7969 14 20.9814 14 21.2002C14 21.6445 14.3418 22 14.7861 22C15.0049 22 15.2031 21.9111 15.3604 21.7607L20.0498 16.9482L24.7393 21.7607C24.8896 21.9043 25.0879 22 25.3066 22C25.7578 22 26.0996 21.6445 26.0996 21.2002C26.0996 20.9814 26.0244 20.7969 25.874 20.6465L20.6582 15.3145C20.4805 15.1299 20.2822 15.0479 20.0498 15.0479Z"
      fill="currentColor"
    />
  </g>
</svg>
